import { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import { authMe } from "../../../api/auth/auth";
import { useNavigate } from "react-router-dom";
import Button from "../../common/Button/Button";
import { FiLogOut } from "react-icons/fi";
import './Header.css';

const Header = ({ onMenuClick }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate()

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await authMe();
        setUser(data);
      } catch (error) {
        console.error("Auth me failed:", error);
      }
    };

    fetchUser();
  }, []);

  const handleLogout = () =>{
    localStorage.removeItem('access_token')
    navigate("/login", { replace: true });
  }


  return (
    <nav
      className="navbar d-flex justify-content-between align-items-center px-3"
      style={{ background: "#F5F7F9", minHeight: "60px" }}
    >
      <button
        className="btn d-lg-none"
        onClick={onMenuClick}
        style={{ fontSize: "1.2rem" }}
      >
        <FaBars />
      </button>

      <div style={{ color: "#C39B22", fontWeight: 600 , paddingLeft : '20px' }}>
        Hi, {user?.data?.name || "Admin"}
      </div>

      <button className="logout-btn" onClick={handleLogout}>
        <FiLogOut size={18} />
        <span>Logout</span>
      </button>

    </nav>
  );
};

export default Header;
